import {
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  FormErrorIcon,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Link,
  Stack,
} from '@chakra-ui/react';
import { Link as ReactLink } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { FC } from 'react';
import { ForgotUserNameResponse } from '@frx/frx-services';
import { Notification } from '../notification';
import { StJude } from '../../assets';
import { getDataTracking } from '../../utils';

export interface RecoverIdentityFormProps {
  isLoading?: boolean;
  message: ForgotUserNameResponse['message'];
  onSubmit: (values: any) => void;
}

export const RecoverIdentityForm: FC<RecoverIdentityFormProps> = ({
  isLoading,
  message,
  onSubmit,
}) => {
  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm();

  const handleIdentity = (values: any) => onSubmit(values);

  return (
    <Center>
      <Box w={['100%', '384px']}>
        <Stack spacing={4}>
          <Box mb="2rem" mt="2rem">
            <Center>
              <StJude width="100px" />
            </Center>
            <Flex flexDirection="column">
              <Center>
                <Heading size="md">Log in</Heading>
              </Center>
              <Center>
                <Heading size="sm" mt="1rem">
                  with your St. Jude account
                </Heading>
              </Center>
            </Flex>
          </Box>
          {message && (
            <Notification
              message={message}
              status="success"
              messageCallback={
                <Link
                  as={ReactLink}
                  to="/login"
                  {...getDataTracking('returnToLogin')}
                  color="brand.secondary.swatch4"
                >
                  Return to login
                </Link>
              }
            />
          )}
          <form onSubmit={handleSubmit(handleIdentity)}>
            <Stack spacing={6}>
              <FormControl isInvalid={!!errors?.email}>
                <FormLabel htmlFor="email">Email</FormLabel>
                <Input
                  id="email"
                  {...register('email', {
                    required: 'Email is required',
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Enter a valid e-mail address',
                    },
                  })}
                />
                <FormErrorMessage>
                  <>
                    <FormErrorIcon />
                    {errors?.email?.message}
                  </>
                </FormErrorMessage>
              </FormControl>
              <Button
                colorScheme="blue"
                type="submit"
                isLoading={isLoading}
                w="100%"
                {...getDataTracking('credentialsSubmit')}
              >
                Submit
              </Button>
            </Stack>
          </form>
        </Stack>
      </Box>
    </Center>
  );
};
